package org.lennycodes.hldi.constants

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.invoke
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

object HLDITheme {

    object Colors {
        val primary = Color.rgb(11, 102, 35)
        val secondary = Color.rgb(46, 139, 87)
        val accent = Color.rgb(144, 238, 144)
        val background = Color.rgb(245, 245, 245)
        val text = Color.rgb(34, 34, 34)
        val white = Color.rgb(255, 255, 255)
        val lightGray = Color.rgb(245, 245, 245)
        val mediumGray = Color.rgb(158, 158, 158)
       val tranparent =  rgba(255, 0, 0, 0)
    }


    val baseStyle = CssStyle {

        "*" {
            margin(0.px)
            padding(0.px)
            boxSizing(BoxSizing.BorderBox)
        }


        "body" {

            fontFamily(
                "Inter",
                "sans-serif"
            )


            color(
                Colors.text
            )

            backgroundColor(
                Colors.background
            )

        }


        "h1,h2,h3,h4,h5,h6" {

            fontFamily(
                "Playfair Display",
                "serif"
            )

            fontWeight(
                700
            )

        }

    }



    val cardStyle = CssStyle {



    }



    val buttonStyle = CssStyle {

    }


}